import styled, { css } from "styled-components";

import { NotificationFooterContainerContainer } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterContainer/styles";
import { NotificationFooterDotContainer } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterDot/styles";

interface INotificationsButtonContainerProps {
  hasNewNotifications: boolean;
}

export const NotificationsButtonContainer = styled.div<INotificationsButtonContainerProps>`
  position: relative;

  button[id$="notifications-button"] {
    padding: 10px;

    svg path {
      transition: 0.3s all;
      stroke: ${({ theme }) => theme.colors.globalTopbar.iconsColor};
      stroke-width: 1.5px;
    }
  }

  :has([data-is-open="true"]) {
    button[id$="notifications-button"] svg path {
      stroke: white;
    }
  }

  ::after {
    content: "";
    width: 8px;
    height: 8px;
    background-color: red;
    border-radius: 50%;
    position: absolute;
    right: 10px;
    top: 8px;

    opacity: 0;
    transition: 0.3s all;

    pointer-events: none;

    ${({ hasNewNotifications }) =>
      hasNewNotifications &&
      css`
        opacity: 1;
      `}
  }
`;

interface INotificationsContainerProps {
  isOpen: boolean;
}

export const NotificationsContainer = styled.div<INotificationsContainerProps>`
  position: absolute;
  top: 4rem;
  right: 0;
  border-radius: 8px;

  overflow: hidden;

  border: 1px solid
    ${({ theme }) => (theme.mode === "dark" ? "#ffffff14" : "#9a9a9a")};

  width: 400px;
  color: white;

  opacity: 0;
  pointer-events: none;
  transition: 0.3s all;

  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      pointer-events: all;
    `}

  @media(max-width: 1366px) {
    width: 314px;

    ${NotificationFooterDotContainer} {
      display: none;
    }

    ${NotificationFooterContainerContainer} {
      flex-wrap: wrap;
      gap: 8px 0;
      flex-direction: column-reverse;
      align-items: flex-start;
    }
  }
`;
